<section class="line-item-modal-container">
    <h5 style="margin: 23px 0px 2px 23px;font-weight: bold;">Frieght Charges</h5>
    <div class="modal-body">
        <div class="modal-body__tabs">
            <ul class="ps-0">
                <ng-container *ngFor="let tab of prTabs; let tabIndex = index">
                    <li class="text-action" [ngClass]="{
                        'active' : tab.active
                    }">
                        <a (click)="changeTab(tab)" class="cursor-pointer">{{ tab.title }}</a>
                    </li>
                </ng-container>
            </ul>
        </div>
        <div class="modal-body__content">
            <div class="card mt-1">
                <div class="card-body p-4">
                    <div class="d-flex mb-4 mt-1 justify-content-between">
                        <ng-container *ngIf="activeTab">
                            <app-tab-content (eventOutput)="onTabDataUpdate($event)"></app-tab-content>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <a class="btn btn-outline-primary mx-2" (click)="onModalClose()">Cancel</a>
        <button *ngIf="!withRC && lineItemDetail?.line_item_status !== 'APPROVED'" class="btn btn-primary mx-2 text-white" [disabled]="!isFormValid() || !isBalanceValid" (click)="saveDetails()">Save Details</button>
    </div>
</section>
